// extracted by mini-css-extract-plugin
export default {"spin":"style_spin__4FCp9","iconpark-spin":"style_iconpark-spin__X1pwQ","rtl":"style_rtl__8gIHT","iconpark-spin-rtl":"style_iconpark-spin-rtl__af0tV"};